import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=282b2608&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=282b2608&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b2608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282b2608')) {
      api.createRecord('282b2608', component.options)
    } else {
      api.reload('282b2608', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=282b2608&scoped=true", function () {
      api.rerender('282b2608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/Contact.vue"
export default component.exports